<template>

<div style="background-color: #495057; height:100vh;" class="flex-container">

  <div id="loginDiv">
    <h3 id="welcomeTitle"> Register yourself to linkdeat</h3>
        
    <div class="flex-container-first">
    
        <form @submit.prevent="signup">
            <div class="form-group">
                <input placeholder="first name" type="text" v-model="firstName" name="first name" class="form-control" />
            </div>
            <div class="form-group">
                <input placeholder="last name" type="text" v-model="lastName" name="last name" class="form-control" />
            </div>
            <div class="form-group">
                <input placeholder="email" type="email" v-model="email" name="email" class="form-control" />
            </div>            
            <div class="form-group">
                <input placeholder="preferable name" type="text" v-model="username" name="username" class="form-control" />
            </div>
            <div class="form-group">
                <input placeholder="preferable password" type="password" v-model="password" name="password" class="form-control" />
            </div>
            <br>
            <div class="form-group">
                <button class="btn btn-primary" >Sign Up</button>
            </div>
        </form>
    </div>
    <div style="text-align:center;">
      <router-link to="/">Back to login</router-link>
    </div>
  </div>
</div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'Signup',
  data() {
    return {
      firstName: '',
      lastName: '',
      username: '',
      password: '',
      email: '',
      error: '',
    }
  },
  methods: {
    signup() {
      let user = 'username='+this.username+'&password='+this.password+'&firstName='+this.firstName+'&lastName='+this.lastName+'&email='+this.email
      axios.post('https://linkdeat.ddns.net/django_api/signup/', user)
      //axios.post('http://localhost:5000/signup', newUser)
        .then( res => {
            if (res.status === 200) {
              this.$router.push('/home');
            }
        }, err => {
          //console.log(err.response)
          this.error = err.response.data.error
        })
    }
  }
}
</script>


